<ng-container *ngIf="cargado && hayLineas">

  <div class="mc-hd">
    <h2>Historial reciente</h2>
    <a class="mc-more" [routerLink]="['/historial-puntos']">Ver historial completo</a>
  </div>

  <div class="hr-card">
    <div class="hr-linea" *ngFor="let l of lineas">
      <div class="hr-info">
        <b>{{ l.concepto }}</b>
        <span>{{ l.fecha | date:'d \'de\' MMMM':'':'es-AR' }}</span>
      </div>
      <div class="hr-puntos">{{ l.puntos >= 0 ? '+' : '' }}{{ l.puntos | number:'1.0-0':'es-AR' }} <span>puntos</span></div>
    </div>
  </div>

</ng-container>
